import { createI18n, lang, currentLang, setLang } from '@lib/i18n/core'
import commonZhHans from './locales/common/zh-Hans.json'
import commonZhHant from './locales/common/zh-Hant.json'
import staffZhHans from './locales/staff/zh-Hans.json'
import staffZhHant from './locales/staff/zh-Hant.json'
import strategyZhHans from './locales/kpi-analyze/zh-Hans.json'
import strategyZhHant from './locales/kpi-analyze/zh-Hant.json'
import exportZhHans from './locales/export/zh-Hans.json'
import exportZhHant from './locales/export/zh-Hant.json'
import kpiOverviewZhHans from './locales/kpi-overview/zh-Hans.json'
import kpiOverviewZhHant from './locales/kpi-overview/zh-Hant.json'
import kpiAnalyzeZhHans from './locales/kpi-breakdown/zh-Hans.json'
import kpiAnalyzeZhHant from './locales/kpi-breakdown/zh-Hant.json'
import comparePickerZhHans from './locales/compare-picker/zh-Hans.json'
import comparePickerZhHant from './locales/compare-picker/zh-Hant.json'
import sqlWorkplaceZhHans from './locales/sql-workplace/zh-Hans.json'
import sqlWorkplaceZhHant from './locales/sql-workplace/zh-Hant.json'
import metricGlossaryZhHans from './locales/metric-glossary/zh-Hans.json'
import metricGlossaryZhHant from './locales/metric-glossary/zh-Hant.json'
import userSegmentationZhHans from './locales/user-segmentation/zh-Hans.json'
import userSegmentationZhHant from './locales/user-segmentation/zh-Hant.json'
import externalViewZhHans from './locales/external-view/zh-Hans.json'
import externalViewZhHant from './locales/external-view/zh-Hant.json'
import reportSubscriptionZhHans from './locales/report-subscription/zh-Hans.json'
import reportSubscriptionZhHant from './locales/report-subscription/zh-Hant.json'
import metricAlertZhHans from './locales/metric-alert/zh-Hans.json'
import metricAlertZhHant from './locales/metric-alert/zh-Hant.json'
import apiErrorZhHans from './locales/api-error/zh-Hans.json'
import apiErrorZhHant from './locales/api-error/zh-Hant.json'
import tourZhHans from './locales/tour/zh-Hans.json'
import eventLoggingZhHans from './locales/event-logging/zh-Hans.json'
import tourZhHant from './locales/tour/zh-Hant.json'
import versionNoticeZhHans from './locales/version-notice/zh-Hans.json'
import versionNoticeZhHant from './locales/version-notice/zh-Hant.json'
import eventLoggingZhHant from './locales/event-logging/zh-Hant.json'

function deepMerge(target, source) {
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = deepMerge(target[key] || {}, source[key])
    } else {
      target[key] = source[key]
    }
  }
  return target
}

function mergeAll(...sources) {
  return sources.reduce((acc, src) => deepMerge(acc, src), {})
}

const locals = {
  'zh-Hans': mergeAll(commonZhHans, staffZhHans, strategyZhHans, exportZhHans, kpiOverviewZhHans, kpiAnalyzeZhHans, comparePickerZhHans, sqlWorkplaceZhHans, metricGlossaryZhHans, userSegmentationZhHans, reportSubscriptionZhHans, metricAlertZhHans, apiErrorZhHans, tourZhHans, eventLoggingZhHans, versionNoticeZhHans, externalViewZhHans),
  'zh-Hant': mergeAll(commonZhHant, staffZhHant, strategyZhHant, exportZhHant, kpiOverviewZhHant, kpiAnalyzeZhHant, comparePickerZhHant, sqlWorkplaceZhHant, metricGlossaryZhHant, userSegmentationZhHant, reportSubscriptionZhHant, metricAlertZhHant, apiErrorZhHant, tourZhHant, eventLoggingZhHant, versionNoticeZhHant, externalViewZhHant),
}

const { t, nt } = createI18n(locals)

export { t, nt, lang, currentLang, setLang }
